{
  "name": "@ns/company-data-access-answer",
  "version": "1.2.0",
  "requiredPermission": "DATA_SHARING_MANAGE",
  "description": "Share data with a company that asked for it, or decline",
  "inputs": {
    "GRANT_ID": {
      "type": "string"
    },
    "RELATIONSHIP_ID": {
      "type": "string"
    }
  },
  "outcomes": {
    "answered": {
      "serverOnly": true
    }
  }
}
